import axios from "../utils/axios";

/**
 * 统一翻译接口，所有翻译都走 api/pandagpt/v1/m/facebook_comments/translate
 * @param {string} text 待翻译文本
 * @param {Object} [extraParams={}] 额外参数（如有，原样透传）
 * @returns {Promise<{code:number;msg:string;data:string}>}
 */
export function translateContent(text, extraParams = {}) {
  return axios("POST", `api/pandagpt/v1/m/facebook_comments/translate`, { content: text, ...extraParams }, false, false, true);
}

/**
 * 翻译评论（已切换到统一接口，建议直接使用 translateContent）
 * @param {string} comment_id 评论id
 * @param {string} cs_platform 平台 1 facebook 2 ins
 * @returns {Promise<{code:number;msg:string;data:string}>}
 */
export function translateComment(comment_id, cs_platform) {
  return translateContent("", { comment_id, cs_platform });
}

/**
 * 通用文本翻译接口（已切换到统一接口，建议直接使用 translateContent）
 * @param {{text:string;language?:string;[key:string]:any}} param 翻译参数
 * @returns {Promise<{code:number;msg:string;data:string}>}
 */
export function translateText(param = {}) {
  return translateContent(param?.text || param?.content || "", param);
}
